import {
  FormControl,
  FormLabel,
  Heading,
  Skeleton,
  Switch,
  Text,
} from '@chakra-ui/react'

import {
  useUpdateUserSettings,
  useUserSettings,
} from '@/react-query/user-settings'
import Card from '@/views/components/Card'

export const LiveTranscriptionSettings = () => {
  const { data: userSettings, isLoading } = useUserSettings()
  const updateUserSettings = useUpdateUserSettings()

  return (
    <Card w={'100%'} p={6} px={10}>
      <Heading size={'md'}>Live Transcription</Heading>
      <Text color="gray.600" fontSize="sm" mt={2}>
        Show real-time transcription while recording interviews
      </Text>
      <FormControl mt={6} display={'flex'} alignItems={'center'}>
        <Skeleton
          rounded={'1.25rem'}
          isLoaded={!isLoading}
          startColor="#f5f5f5"
          endColor="#d7d7d7"
        >
          <Switch
            id="enable-live-transcription"
            onChange={(event) => {
              event.preventDefault()
              const value = event.target.checked
              updateUserSettings.mutate({
                enableLiveTranscription: value,
              })
            }}
            isChecked={userSettings?.enableLiveTranscription || false}
            size={'lg'}
            variant={'brand-black'}
          />
        </Skeleton>
        <FormLabel htmlFor="enable-live-transcription" mb="0" ml={'4'}>
          Enable live transcription during recording
        </FormLabel>
      </FormControl>
    </Card>
  )
}
